"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactComponents = require("@ui-propulsion/react-components");
var _propTypes = require("prop-types");
var _ConfirmAccount = _interopRequireDefault(require("./ConfirmAccount.styles"));
function ConfirmAccount(_ref) {
  var accounts = _ref.accounts,
    handleSelection = _ref.handleSelection,
    selectedAccount = _ref.selectedAccount;
  var classes = (0, _ConfirmAccount["default"])();
  return /*#__PURE__*/_react["default"].createElement(_reactComponents.Container, {
    className: classes.root,
    "data-testid": "confirmAccount"
  }, /*#__PURE__*/_react["default"].createElement(_reactComponents.RadioGroup, {
    "aria-label": "Confirm Account",
    name: "Confirm Account"
  }, accounts.map(function (account) {
    var accountDescription = /*#__PURE__*/_react["default"].createElement("div", {
      className: classes.labelWrap,
      key: "".concat(account.institutionName).concat(account.lastFour)
    }, /*#__PURE__*/_react["default"].createElement("span", null, account.institutionName, " ", account.accountName, " (****", account.lastFour, ")"), account.balance && /*#__PURE__*/_react["default"].createElement("span", {
      className: classes.balanceConfirmAccount
    }, "Current balance: ".concat(account.balance)));
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: account.identifier
    }, /*#__PURE__*/_react["default"].createElement(_reactComponents.FormControlLabel, {
      control: /*#__PURE__*/_react["default"].createElement(_reactComponents.RadioButton, {
        onClick: function onClick(event) {
          return handleSelection(event, account);
        },
        checked: account.identifier === selectedAccount.identifier,
        inputProps: account.inputProps
      }),
      value: account.identifier,
      label: accountDescription
    }));
  })));
}
ConfirmAccount.propTypes = {
  /**
   * Accounts properties
   */
  accounts: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    identifier: _propTypes.string,
    institutionName: _propTypes.string,
    accountName: _propTypes.string,
    lastFour: _propTypes.string,
    balance: _propTypes.string
  })).isRequired,
  selectedAccount: (0, _propTypes.shape)({
    identifier: _propTypes.string,
    institutionName: _propTypes.string,
    accountName: _propTypes.string,
    lastFour: _propTypes.string,
    balance: _propTypes.string
  }),
  handleSelection: _propTypes.func.isRequired
};
ConfirmAccount.defaultProps = {
  selectedAccount: {}
};
var _default = ConfirmAccount;
exports["default"] = _default;
